import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  faUserCircle,
  faAddressBook,
  faGraduationCap,
  faFileContract,
  faFile,
  faCalendarAlt,
  faEnvelope,
  faPeopleGroup,
  faUserTie,
  faQuestion,
} from '@fortawesome/free-solid-svg-icons';
import { getRentals } from '../../actions/rentalActions';
import { getAdvisorCourses } from '../../actions/courseActions';
import ActionList from './ActionList';

const ManagerProfileActions = () => {
  const dispatch = useDispatch();
  const [hasAssignedCourses, setHasAssignedCourses] = useState(false);

  useEffect(() => {
    dispatch(getRentals());
    
    // Check if the manager has any assigned courses
    dispatch(getAdvisorCourses()).then((result) => {
      if (result && result.payload && result.payload.length > 0) {
        setHasAssignedCourses(true);
      }
    });
  }, [dispatch]);

  const personalActions = [{ route: '/edit-profile', text: 'Profil bearbeiten', icon: faUserCircle }];

  const hilfskraefteManagementActions = [
    {
      route: '/tutor-overview',
      text: 'Benutzer Übersicht',
      icon: faAddressBook,
    },
    { route: '/allapplications-overview', text: 'Bewerbungen', icon: faFile },
    {
      route: '/course-overview',
      text: 'Veranstaltungen',
      icon: faGraduationCap,
    },
    { route: '/contracts', text: 'Verträge', icon: faFileContract },
  ];

  const setupActions = [
    {
      route: '/semester-overview',
      text: 'Semester Übersicht',
      icon: faCalendarAlt,
    },
    {
      route: '/metacourse-overview',
      text: 'Metaveranstaltungen',
      icon: faGraduationCap,
    },
  ];

  const rolesActions = [{ route: '/group-overview', text: 'Gruppen', icon: faPeopleGroup }];

  const mailActions = [
    { route: '/send-mail', text: 'Mail versenden', icon: faEnvelope },
    { route: '/mail-overview', text: 'Mail Vorlagen', icon: faAddressBook },
  ];

  const advisorActions = [
    { route: '/advisor-classes', text: 'Meine Kurse', icon: faUserTie },
    {
      route: '/advisor-course-overview',
      text: 'Veranstaltungen',
      icon: faGraduationCap,
    },
    {
      route: '/advisor-metacourse-overview',
      text: 'Metaveranstaltungen',
      icon: faGraduationCap,
    },
    { route: '/faq', text: 'FAQ', icon: faQuestion },
  ];

  return (
    <div className="mb-4">
      <ActionList items={personalActions} title="Persönlich" />
      <ActionList items={hilfskraefteManagementActions} title="Hilfskräfte Management" />
      <ActionList items={setupActions} title="Aufstellen" />
      <ActionList items={rolesActions} title="Rollen" />
      <ActionList items={mailActions} title="Mail" />
      {hasAssignedCourses && (
        <ActionList items={advisorActions} title="Kursverwaltung (als Übungsleiter)" />
      )}
    </div>
  );
};

export default ManagerProfileActions;